import React from 'react';
import { cn } from '../lib/utils';
import { SaveStatus } from '../hooks/useSaveIndicator';

interface SaveIndicatorProps {
    status: SaveStatus;
    className?: string;
}

export default function SaveIndicator({ status, className }: SaveIndicatorProps) {
    if (status === 'idle') return null;

    return (
        <span
            className={cn(
                "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium transition-all duration-300",
                status === 'saving' && "bg-primary/10 text-primary",
                status === 'saved' && "bg-emerald-50 text-emerald-600 animate-fade-out",
                className
            )}
        >
            {status === 'saving' ? (
                <>
                    <span className="material-symbols-outlined text-[13px] animate-spin">progress_activity</span>
                    Saving...
                </>
            ) : (
                <>
                    <span className="material-symbols-outlined text-[13px]">check_circle</span>
                    Saved
                </>
            )}
        </span>
    );
}
